import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getClasses = ({
  isNestedItem,
  dsf_open,
  dsf_selected,
  dsf_always_open,
  dsf_collapsed,
  dsf_submenu,
  disabled
}) => {
  const textClasses = [];
  const bgClasses = [];
  const focusStyles = [
    "outline-none",
    "focus-visible:outline",
    "focus-visible:outline-1",
    "focus-visible:outline-offset-1",
    "focus-visible:outline-secondary-300"
  ];
  if (dsf_selected && !isNestedItem) {
    focusStyles.push("focus-visible:bg-primary-400");
  } else {
    focusStyles.push("focus-visible:bg-neutral-100");
  }
  const layoutClasses = ["flex", "w-full", "flex-row", "dsf-p-s", "rounded-sm", "items-center"];
  layoutClasses.push(dsf_submenu ? "gap-8" : "gap-16");
  if (disabled) {
    layoutClasses.push("cursor-not-allowed");
    textClasses.push("text-neutral-300");
    bgClasses.push("bg-neutral-100");
  } else if (!dsf_always_open || dsf_always_open && dsf_collapsed) {
    layoutClasses.push("cursor-pointer");
    if (dsf_selected) {
      if (isNestedItem || dsf_submenu) {
        textClasses.push(dsf_collapsed ? "text-neutral-0" : "text-neutral-700");
        bgClasses.push("bg-neutral-100", "hover:bg-neutral-200");
      } else {
        textClasses.push("text-neutral-0");
        bgClasses.push("bg-primary-300", "hover:bg-primary-400");
      }
    } else {
      textClasses.push("text-neutral-700");
      bgClasses.push("hover:bg-neutral-100");
      if (dsf_collapsed && dsf_open) {
        bgClasses.push("bg-neutral-50");
      }
    }
  } else {
    layoutClasses.push("cursor-default");
    textClasses.push("text-neutral-700");
  }
  if (dsf_collapsed && !isNestedItem) {
    layoutClasses.push("justify-center", "min-w-40", "h-40");
  } else {
    layoutClasses.push("h-32");
  }
  return concatClasses([...layoutClasses, ...focusStyles, ...textClasses, ...bgClasses]);
};
export {
  getClasses
};
